import request from '@/utils/request'


// 查询用户体重记录列表
export function listWeight(query) {
  return request({
    url: '/joe/user-weight/list',
    method: 'get',
    params: query
  })
}

export function getLargeScreenUserNum(query) {
  return request({
    url: '/joe/user-body/getLargeScreenUserNum',
    method: 'get',
    params: query
  })
}

export function getOnlineUserCount(query) {
  return request({
    url: '/joe/user-body/getOnlineUserCount',
    method: 'get',
    params: query
  })
}

export function getThreeDayOnlineUser(query) {
  return request({
    url: '/joe/user-body/getThreeDayOnlineUser',
    method: 'get',
    params: query
  })
}

export function getUserAgeData(query) {
  return request({
    url: '/joe/user-body/getUserAgeData',
    method: 'get',
    params: query
  })
}

export function getSleepUser(query) {
  return request({
    url: '/joe/user-body/getSleepUser',
    method: 'get',
    params: query
  })
}

export function getErrorData(query) {
  return request({
    url: '/joe/user-body/getErrorData',
    method: 'get',
    params: query
  })
}


export function getNewUserList(query) {
  return request({
    url: '/joe/user-body/getNewUserList',
    method: 'get',
    params: query
  })
}
// 查询用户体重记录分页
export function pageWeight(query) {
  return request({
    url: '/joe/user-weight/page',
    method: 'get',
    params: query
  })
}

// 查询用户体重记录详细
export function getWeight(data) {
  return request({
    url: '/joe/user-weight/detail',
    method: 'get',
    params: data
  })
}

// 新增用户体重记录
export function addWeight(data) {
  return request({
    url: '/joe/user-weight/add',
    method: 'post',
    data: data
  })
}

// 修改用户体重记录
export function updateWeight(data) {
  return request({
    url: '/joe/user-weight/edit',
    method: 'post',
    data: data
  })
}

// 删除用户体重记录
export function delWeight(data) {
  return request({
    url: '/joe/user-weight/delete',
    method: 'post',
    data: data
  })
}
